import ApiTablePage from '../../components/common/ApiTablePage';
import { API_CONFIG } from '../../config/api.config';

const columns = [
  { label: 'Candidate ID', keys: ['candidate_id', 'id', 'org_id'] },
  { label: 'Business Name', keys: ['business_name', 'name'] },
  { label: 'City', keys: ['city'] },
  { label: 'State', keys: ['state', 'state_code'] },
  { label: 'Match Score', keys: ['score', 'match_score'] },
];

const HCOMatching = () => (
  <ApiTablePage
    title="HCO Matching"
    subtitle="HCO match candidate evaluation"
    apiConfig={API_CONFIG.matching.hcoMatching}
    initialPayload={{}}
    columns={columns}
  />
);

export default HCOMatching;
